<template>
    <a class="btn btn-dark-blue flex--no-shrink"
       @click.prevent="$emit('click')">
        <i class="fa-solid fa-bars mobile-only"
           :class="{ 'update-available': updateAvailable }"></i>
        <i class="fa-solid fa-grid-2 desktop-only"></i>
        <span class="text">{{ l('NAV.MENU_BTN') }}</span>
    </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    emits: ['click'],

    computed: {
        ...mapGetters([
            'updateAvailable',
        ]),
    },
};
</script>
